<template>
  <div class="h-100 my-5">
    <b-button
      type="submit"
      class="myButton"
      @click="$router.go(-1)">
      {{ $t('common.Cancel') }}
    </b-button>
    <div class="dp02 p-3 mt-3">
      <div class="text-center col-lg-12">
        <h2>{{ $t('entities.Sample.Singular') }} {{ customerName }}</h2>
      </div>
      <div class="col-6">
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.status') }}:</label>
          </div>
          <div class="col-lg-9">
            <SampleStatusInput v-model="status" />
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-3">
            <label for="gender">{{ $t('fields.updatedAt') }}:</label>
          </div>
          <div class="col-lg-9">
            <b-form-input
              class="myInput"
              :disabled="true"
              v-model="updatedAtFormatted" />
          </div>
        </div>
      </div>
      <div class="col-lg-12 text-center">
        <b-button
          class="mt-3 myButton align-middle"
          type="submit"
          @click="submit()">
          {{ $t('EditSample.Header') }}
        </b-button>
      </div>
    </div>
    <b-modal id="modal-center"
             ref="scanModal"
             centered
             :static="true">
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 text-center">
          <h3>
            {{ $t('common.ScanBarcode') }}
          </h3>
        </div>
      </template>
      <template #modal-footer="{ cancel, ok }">
        <b-button
          variant="danger"
          @click="$refs.scanModal.hide(); currentlyScanning = 0; $barcodeScanner.destroy()">
          {{ $t('common.Cancel') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import SampleStatusInput from '@components/input/SampleStatusInput';

export default {
  name: 'EditSample',
  components: {
    SampleStatusInput
  },
  data() {
    return {
      editing: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    status: {
      get() {
        return this.$store.state.editSample.status;
      },
      set(val) {
        this.setStatus(val);
      }
    },
    hasBarcode: {
      get() {
        return this.$store.state.editSample.hasBarcode;
      }
    },
    updatedAtFormatted() {
      return this.$moment(this.updatedAt).format('DD.MM.YYYY HH:mm:ss');
    },
    ...mapState('editSample', ['customerName', 'updatedAt', 'customerId']),
  },
  mounted() {
    this.resetContext();
    this.setSampleId(this.id);
    this.fetchSample();
  },
  methods: {
    ...mapMutations({
      setSampleId: 'editSample/setSampleId',
      setStatus: 'editSample/setStatus',
    }),
    ...mapActions({
      resetContext: 'editSample/resetContext',
      editSample: 'editSample/editSample',
      fetchSample: 'editSample/fetchSample'
    }),
    scanBarcode(code) {
      this.axios.post('admin/barcodes/assign', {
        CustomerId: this.customerId,
        Code: code
      }).then((response) => {
        this.$root.$bvToast.toast('Čárový kód úspěšně přirazen', {
          title: 'Úspěch',
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        Promise.resolve(response);
        this.submitEditSample();
      }).catch((err) => {
        this.$root.$bvToast.toast('Nepodařilo se přiradit čárový kód', {
          title: 'Nepodařilo se přiradit',
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
        Promise.reject(err);
      });
    },
    async submit() {
      if (this.status === 3 && !this.hasBarcode) {
        this.$refs.scanModal.show();
        this.$barcodeScanner.init(this.scanBarcode)
        return;
      }

      await this.submitEditSample();
    },
    async submitEditSample() {
      this.editSample().then(() => {
        this.$root.$bvToast.toast(this.$t('EditSample.SuccessToast.Body'), {
          title: this.$t('EditSample.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
        this.$root.$router.replace({ name: 'admin.customers.samples.view' });
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('EditSample.FailureToast.Body'), {
          title: this.$t('EditSample.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
